// globalModule.ssr.js
import axios from 'axios'

const axiosInstance = axios.create({
  //baseURL: process.env.VUE_APP_WEBAPI || '', // if you use a base URL
  // ...any interceptors / headers you need
})

import { langConvImpl, siteNameImpl, uniqueImpl } from "./universalmethods.js"
import {advertsloaded, oddstype, bannersize, screensize, tabtype, calendartype,dateformattype} from './globalconstants.js'
export default {
  install(Vue) {

    //langConv Function
    Vue.mixin({
        computed: {
            $advertsloaded() {return advertsloaded},
            $oddstype() {return oddstype},
            $bannersize() {return bannersize},
            $screensize() {return screensize},
            $tabtype() {return tabtype},
            $calendartype() {return calendartype},
            $dateformattype() {return dateformattype},
            
            
        },
  
      methods: {
        // component/template usage
        
        unique(arr, key, wherefield1, whereval1, wherefield2, whereval2) {
          
          return uniqueImpl(arr, key, wherefield1, whereval1, wherefield2, whereval2)},

        langConv(val) {
        if (this.$store) {
            // In SSR, this can be undefined if called too early
            val = langConvImpl(this.$store, val)
          }
          return val
        },
        siteName(val) {
        
        if (this.$store) {   
            //console.log(val) 
             val = siteNameImpl(this.$store, val)
            } 
        return val
        },
                     numbertoCurrency: function (val) {


                    let formattedcurrency = ''

                    // has currency got a symbol
                    let currency = this.$store.state.currency

                    

                    switch (currency) {
                        case 'GBP':
                            formattedcurrency = '£' + val; 
                            break;
                        case 'EUR':
                            formattedcurrency = '€' + val; 
                            break;
                        case 'USD':
                            formattedcurrency = '$' + val; 
                            break;
                        default:
                            formattedcurrency = val;
                            break;
                    }

                   
                        return formattedcurrency
                    

                },


      },
   

            
      
    })

    // Expose for asyncData if needed
    Vue.$globals = {
      langConv: (store, key) => langConvImpl(store, key),
      siteName: (store) => siteNameImpl(store)
    } 

    //siteName function

    const utils = {
        setDefaultCountrySettings: function (storevar) {


          
                    storevar.commit("setCountry", 'EN');
                        storevar.commit("setCountryName", 'United Kingdom');
                        storevar.commit("setCurrency", 'GBP');
                          
                        //to do set regbodies from this default 

                        let regbodies = [];
                        regbodies.push(281); // 281 is united kingdom 

                        storevar.commit("setRegBody", regbodies);

                        storevar.commit("setNoPromo", 0);

                        storevar.commit("setLangFileLoaded", true);  
                        
                        //this.setSelectedBookmakerswithLicense(); - old when linked up to license bodies instead of licenses for country
                        //this.setSelectedBookmakerswithCountryLicense();
                    

                       //this.nowLoadAds();
        },  
        setSelectedBookmakerswithCountryLicense: function(store, localLoader) {
     
                  
                    let sbtemp = [];
                    let sb = [];

                    const bcl = localLoader("bookmakercountrylicenses.json")

                    //insert all the bookers that have a license 
                    store.state.regbody.forEach(function(regbodyitem) {

                        sbtemp = bcl.filter(recs => recs.LID == regbodyitem);
                        sb = sb.concat(sbtemp)
                        
                    })

                     const key = "D"

                    sb = [...new Map(sb.map(item =>[item[key], item])).values()];

                    //set the bookmakers to be the selected bookmakers
                    store.commit("setSelectedbookmakers",sb)

                
        }, 
                siteName: function (val) 
                {
                    
                    let sitename = store.state.sitename ;
                    let shortsitename = 'OG'
                
                    if (sitename == 'search4bets')  {shortsitename = 'S4B'} 
                
                
                    val = val.replace("[sitename]", shortsitename)
                    return val;
              
                },
                //generic axios return 
                async newgenericresultset(wcfurl, jsonparams,spname) {                 

                        
                        var response = await axiosInstance.get(wcfurl, {
                            params: {
                                SPName: spname,
                                Params: jsonparams
                            }});

    
                            if (response.data==null || response.data == ''){          
                                return '';
                            } else {
                                return JSON.parse(response.data);
                            }
                       
                },

                
      // add: (a, b) => a + b,
      // sayHello: name => `Hello SSR, ${name}`,
      // formatDate: d => new Date(d).toISOString()
    }

    // Attach utilities for component usage
    Vue.prototype.$globals = utils

    // Expose on Vue itself for asyncData in SSR
    Vue.$globals = utils
  }
}